import {
  allocationBadgeLabel,
  allocationForBudgetGroup,
} from '../utils/categoryAllocation';
import pt from '../locales/pt';

const TYPE_COLORS = {
  essential: '#7C9E6F',
  lifestyle: '#D4A574',
  personal_investment: '#6B8FA8',
};

const TYPE_ORDER = ['essential', 'lifestyle', 'personal_investment'];

/**
 * Donut por tipo em Despesas — mostra apenas despesas efectivamente
 * registadas (spent_eur) em cada grupo, incluindo Poupança e Investimento.
 * O envelope reservado (ainda não gasto) não entra no gráfico.
 *
 * @param {object | null | undefined} overview — /budgets/overview/
 * @returns {{ id: string, name: string, value: number, color: string, percent: number, total: number }[]}
 */
export function buildExpenseTypeChartData(overview) {
  const groups = overview?.groups || [];
  const totals = {
    essential: 0,
    lifestyle: 0,
    personal_investment: 0,
  };

  for (const group of groups) {
    const allocation = allocationForBudgetGroup(group);
    const spent = Number(group.spent_eur ?? 0);
    if (Number.isFinite(spent) && spent > 0) {
      totals[allocation] += spent;
    }
  }

  const rows = TYPE_ORDER.map((id) => ({
    id,
    name: allocationBadgeLabel(id, pt),
    value: totals[id],
    color: TYPE_COLORS[id],
  })).filter((row) => row.value > 0);

  const total = rows.reduce((sum, row) => sum + row.value, 0);

  return rows.map((row) => ({
    ...row,
    percent: total > 0 ? (row.value / total) * 100 : 0,
    total,
  }));
}
